"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getComputedStyles_1 = require("./getComputedStyles");
var getTagOfNode_1 = require("./getTagOfNode");
function changeElementTag(element, newTag) {
    var _a;
    if (!element || !newTag) {
        return null;
    }
    var newElement = element.ownerDocument.createElement(newTag);
    for (var i = 0; i < element.attributes.length; i++) {
        var attr = element.attributes[i];
        newElement.setAttribute(attr.name, attr.value);
    }
    while (element.firstChild) {
        newElement.appendChild(element.firstChild);
    }
    if (getTagOfNode_1.default(element) == 'P' || getTagOfNode_1.default(newElement) == 'P') {
        _a = getComputedStyles_1.default(element, [
            'margin-top',
            'margin-bottom',
        ]), newElement.style.marginTop = _a[0], newElement.style.marginBottom = _a[1];
    }
    if (element.parentNode) {
        element.parentNode.replaceChild(newElement, element);
    }
    return newElement;
}
exports.default = changeElementTag;
//# sourceMappingURL=changeElementTag.js.map